interface CacheEntry {
    value: string;
    exp: number;
}

/**
 * A simple cache built on top of Browser Storage
 */
export default class LocalCache {
    private readonly storage;
    constructor(storage: Storage) {
        this.storage = storage;
    }

    get(key: string): string | null {
        const rawEntry = this.storage.getItem(key);

        if (!rawEntry) {
            return null;
        }

        let entry: CacheEntry;

        try {
            entry = JSON.parse(rawEntry);
        } catch (e) {
            throw new Error(`Could not parse cache entry: ${rawEntry}`);
        }

        const now = new Date();

        if (now.getTime() > entry.exp) {
           this.storage.removeItem(key);
           return null;
        }

        return entry.value;
    }

    set(key: string, value: string, ttl: number) {
        const now = new Date();
        const entry: CacheEntry = {
            value,
            exp: now.getTime() + ttl,
        };

        this.storage.setItem(key, JSON.stringify(entry));
    }

    getJson<T>(key: string): T | null {
        const item = this.get(key);
        if (!item) {
            return null;
        }

        return JSON.parse(item);
    }

    setJson(key: string, value: any, ttl: number ) {
        const entry = JSON.stringify(value);
        this.set(key, entry, ttl);
    }
}
